import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from '../../../../../reducers';
import { hasBusinessDescriptionLoaded, selectBusinessDescription, selectBusinessDescriptionSelectedDatabaseId } from '../drill-down.selectors';
import { DatabaseType } from '../../../../_study_constants';
import {
  loadBusinessDescription,
  updateBusinessDescriptionCurrentDatabaseId,
  updateBusinessDescriptionSelectedDatabaseId,
} from '../drill-down.actions';
import { DrillDownSectionBaseComponent } from './base/drill-down-section-base.component';
import { BusinessDescription } from '../../../../models/business-description.model';

@Component({
  selector: 'app-drill-down-business-description',
  templateUrl: './business-description.component.html',
  styleUrls: ['./business-description.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class BusinessDescriptionComponent extends DrillDownSectionBaseComponent implements OnInit, OnDestroy {
  businessDescription$: Observable<BusinessDescription>;
  selectedDatabaseId: number;
  hasBusinessDescriptionLoaded: boolean;

  constructor(store: Store<AppState>) {
    super(store);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.businessDescription$ = this.store.pipe(select(selectBusinessDescription));

    this.store
      .pipe(takeUntil(this.destroy$))
      .pipe(select(selectBusinessDescriptionSelectedDatabaseId))
      .subscribe((id) => {
        this.selectedDatabaseId = id;
      });

    this.store
      .pipe(takeUntil(this.destroy$))
      .pipe(select(hasBusinessDescriptionLoaded))
      .subscribe((isLoaded) => {
        this.hasBusinessDescriptionLoaded = isLoaded;
      });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onBusinessDescriptionDatabaseChange(id: string) {
    const databaseId = +id;
    const comparableId = this.companyData.comparableId;

    this.store.dispatch(updateBusinessDescriptionSelectedDatabaseId({ id: comparableId, databaseId }));

    if (this.hasBusinessDescriptionLoaded) {
      this.store.dispatch(updateBusinessDescriptionCurrentDatabaseId({ id: comparableId, databaseId }));
      return;
    }

    this.store.dispatch(loadBusinessDescription({ id: comparableId, uniqueId: this.companyData.uniqueId, databaseId }));
  }

  get isNonBvd(): boolean {
    return (
      this.selectedDatabaseId === DatabaseType.OneSource ||
      this.selectedDatabaseId === DatabaseType.CompustatGlobal ||
      this.selectedDatabaseId === DatabaseType.CompustatNA
    );
  }
}
